export const DELETE_COURSE_VIDEO_FILE = 'DELETE_COURSE_VIDEO_FILE'

export const FETCH_COURSE_VIDEO_FILES = 'FETCH_COURSE_VIDEO_FILES'
